import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState: any = {
  routesStore: [],
  menuFooterStore: [],
};

export const routesSlice = createSlice({
  name: 'routesSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateRoutes: (state, action) => {
      state.routesStore = action.payload;
    },
    updateMenuFooter: (state, action) => {
      state.menuFooterStore = action.payload;
    },
  },
});

export const { updateRoutes, updateMenuFooter } = routesSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const routesState = (state: RootState) => state.routes.routesStore;
export const menuFooterState = (state: RootState) => state.routes.menuFooterStore;

export default routesSlice.reducer;
